import { render, staticRenderFns } from "./GlobalWhiteList.vue?vue&type=template&id=15da06c6"
import script from "./GlobalWhiteList.vue?vue&type=script&lang=js"
export * from "./GlobalWhiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports